// dependecies import ==>
import React, { useContext, useEffect, useState } from "react";
import { Drawer } from "@material-ui/core";
// assets and scss import ==>
import delete_icon from "../../assets/Icon_delete_solid.svg";
import success_tick from "../../assets/dashboard/success_tick.svg";
import warningImg from "../../assets/cancelled.svg";
import "./onlinePendingLogs.scss";
// project file import ==>
import OnlinePendingLogsHeader from "./OnlinePendingLogsTable/OnlinePendingLogHeader";
import PhysicalConsultationModal from "../PhysicalConsultation";
import OnlinePendingLogsMainView from "./OnlinePendingLogsTable/OnlnePendingLogMain";
import OnlinePendingLogsFooterView from "./OnlinePendingLogsTable/OnlinePendingLogFooter";
import OnlinePendingLogsCell from "./OnlinePendingLogsTable/OnlinePendingLogHeader/onlinePendingLogsCell";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext";
import C2CMiddlePopup from "../common/Popups/C2CMiddlePopup";
// constant import ==>
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import {
  CLINIC_PENDING_APPT,
  INSTANT_CONSULT,
  ONLINE_PENDING_APPT_DELETE,
} from "./OnlinePendingLogsApiHandler/apiConstant";
import {
  API_FILTER_LIST,
  APPLICABLE_ROLE,
  DEFAULT_PENDING_PAYLOAD,
  PENDING_HEADER_LIST,
} from "./constant";
import { USER_ROLE, USER_TYPE } from "../../Util/constants";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import AlertMsgPopup from "../common/AlertMsgPopup";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";

export const OnlinePendingLogs = (props) => {
  const { openPopup } = props;

  const doctor_context = useContext(DoctorContext);

  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  const [pendingAppointments, setPendingAppointments] = useState([]);
  const [editedAppointment, setEditedAppointment] = useState({});
  const [showPhysicalConsultationModal, setShowPhysicalConsultationModal] =
    useState(false);
  const [deletedAppointment, setDeletedAppointment] = useState({});
  const [showDeleteAppointmentModal, setShowDeleteAppointmentModal] =
    useState(false);
  const [headerData, setHeaderData] = useState(PENDING_HEADER_LIST);
  const [loading, setLoading] = useState(true);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0);
  const [apiParams, setApiParams] = useState({ ...DEFAULT_PENDING_PAYLOAD });
  const [showSuccessFailurePopup, setShowSuccessFailurePopup] = useState(false);
  const [iconType, setIconType] = useState("");
  const [titleMsg, setTitleMsg] = useState("");
  const [subtitleMsg, setSubtitleMsg] = useState("");
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [alertMsgPop, setAlertMsgPop] = useState("");
  // Lifecycle Methods ===>
  const initializeHeaderData = (header, list) => {
    header.forEach((obj) => {
      if (obj.title === "DOCTOR NAME") {
        if (list?.length > 0) {
          list.forEach((val) => {
            val.selected = false;
            if (val.value === "all") {
              val.selected = true;
            }
          });
        }
        obj.menuData = list;
      } else if (obj.title === "STATUS") {
        obj.menuData.forEach((val) => {
          val.selected = false;
          if (val.value === "all") {
            val.selected = true;
          }
        });
      }
    });
    return header;
  };

  useEffect(() => {
    let arr = [],
      arr1 = [],
      doctorList = JSON.parse(JSON.stringify(doctor_context.selectedDoctor));
    doctorList.map((data) => arr.push(data.doctor_id) && arr1.push(data));
    let list = [{ name: "All", value: "all", doctor_id: arr }, ...arr1];

    const updatedHeaderData = initializeHeaderData([...headerData], list);
    setHeaderData(updatedHeaderData);

    if (
      doctorRole === USER_ROLE.DOCTOR_ADMIN ||
      doctorRole === USER_ROLE.RESOURCE_ADMIN ||
      userType === APPLICABLE_ROLE.STAFF
    ) {
      setApiParams({ ...apiParams, doctor_id: arr });
    } else {
      setApiParams({ ...apiParams, doctor_id: [userId] });
    }
  }, [doctor_context.selectedDoctor]);

  useEffect(() => {
    if (apiParams?.doctor_id?.length > 0) {
      fetchPendingAppointments(apiParams);
    }
  }, [apiParams]);

  // <===

  // Actions ===>

  const deleteAppointment = (appointment) => {
    setDeletedAppointment(appointment);
    setShowDeleteAppointmentModal(true);
  };

  const editAppointment = (appointment) => {
    setEditedAppointment(appointment);
    setShowPhysicalConsultationModal(true);
  };

  const onDrawerClose = () => {
    let header = [...headerData];
    header.forEach((obj) => {
      obj.show_filter = false;
    });
    setHeaderData(header);
    props.closeDrawerCallback();
  };

  const handleCloseDeletePopup = () => {
    setShowDeleteAppointmentModal(false);
  };

  const handleClosePopup = () => {
    setShowSuccessFailurePopup(false);
  };

  const onPageChange = (val) => {
    applyParams({ [API_FILTER_LIST.PAGENO]: val });
  };

  const handleRefreshedData = () => {
    applyParams({ ...apiParams });
  };

  const applyParams = (params) => {
    if (
      doctorRole === USER_ROLE.DOCTOR_ADMIN ||
      doctorRole === USER_ROLE.RESOURCE_ADMIN ||
      userType === APPLICABLE_ROLE.STAFF
    ) {
      setApiParams({ ...apiParams, ...params });
    } else {
      setApiParams({ ...apiParams, ...params, doctor_id: [userId] });
    }
  };

  // <===

  // Api Calls ===>

  const fetchPendingAppointments = (data) => {
    setLoading(true);
    const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
    let payload = {
      ...apiParams,
      ...data,
    };
    payload["clinic_id"] = "";
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      payload["clinic_id"] = clinicId;
    }
    c2cPostApiHandler(CLINIC_PENDING_APPT, payload)
      .then(([res, err]) => {
        if (!err) {
          if (res.data.statusCode === 200) {
            let filteredData = res.data.data.pending_appointments.filter(
              (pendingData) => pendingData.payment_method !== "cash"
            );
            setPendingAppointments(filteredData);
            setLoading(false);
            setTotalRecordsCount(res?.data?.total_record);
          } else if (res.data.statusCode === 204) {
            setPendingAppointments([]);
            setLoading(false);
            setTotalRecordsCount(0);
          } else {
            if (res.data.message) {
              setShowSuccessFailurePopup(true);
              setIconType("error");
              setTitleMsg("Error");
              setSubtitleMsg(res.data.message);
              setLoading(false);
            }
          }
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const handleDeleteAppointment = () => {
    handleCloseDeletePopup();
    let requestPayload = {
      appointment_id: deletedAppointment.appointment_id,
      confirm_delete: true,
      doctor_id: deletedAppointment?.doctor_id,
    };
    let api = ONLINE_PENDING_APPT_DELETE;
    if (deletedAppointment.appointment_type === "instant") {
      requestPayload = {
        instant_consult_id: deletedAppointment.appointment_id,
        is_cancelled: true,
      };
      api = INSTANT_CONSULT;
    }
    if (userType === USER_TYPE.STAFF) {
      requestPayload.staff_id = staffId;
    }
    c2cPostApiHandler(api, requestPayload)
      .then(([res, err]) => {
        if (!err && res.data.statusCode === 200) {
          setShowDeleteAppointmentModal(false);
          handleRefreshedData();
          setShowSuccessFailurePopup(true);
          setIconType("success");
          setTitleMsg("Success");
          setSubtitleMsg("Appointment deleted successfully");
        } else {
          setShowSuccessFailurePopup(true);
          setIconType("error");
          setTitleMsg("Error");
          setSubtitleMsg(res.data.message);
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const showSetAppointmentType = (onlineAppointment) => {
    setShowAlertPopup(true);
    setTimeout(() => {
      setShowAlertPopup(false);
    }, 2000);
    if (onlineAppointment) {
      setAlertMsgPop("Link Shared Successfully");
    } else {
      setAlertMsgPop("Appointment Booked Successfully");
    }
  };

  // <===

  // Display UI ===>

  function createPhysicalConsultModelUI() {
    return (
      <>
        {showPhysicalConsultationModal && (
          <PhysicalConsultationModal
            appointmentType={editedAppointment.appointment_type}
            appointmentId={editedAppointment.appointment_id}
            doctor_slug={""}
            closeView={() => {
              setShowPhysicalConsultationModal(false);
              handleRefreshedData();
            }}
            openView={showPhysicalConsultationModal}
            isAddMode={false}
            step={3}
            doctorData={{
              ...props.doctorData,
              ...(+editedAppointment.account_type === 1 && {
                is_resource: "True",
              }),
            }}
            paymentMethod="online"
            existingOrderId={editedAppointment?.order_id}
            handleSetAppointmentType={showSetAppointmentType}
          />
        )}
      </>
    );
  }

  const createDeleteModal = () => {
    return (
      <>
        {showDeleteAppointmentModal && (
          <C2CMiddlePopup
            openPopup={showDeleteAppointmentModal}
            dialogClassName="online-pending-log-delete-popup"
            hideCloseIcon={true}
            titleImg={delete_icon}
            leftBtn={"Yes"}
            rightBtn={"No"}
            title="Delete Pending Appointment"
            subtitle="Once deleted, the link will not be available for the patient to book an appointment. Are you sure you want to continue?"
            handleLeftBtnClick={handleDeleteAppointment}
            handleRightBtnClick={handleCloseDeletePopup}
          />
        )}
      </>
    );
  };

  const displaySuccessFailurePopup = () => {
    return (
      <>
        {showSuccessFailurePopup && (
          <C2CMiddlePopup
            openPopup={showSuccessFailurePopup}
            dialogClassName="online-pending-log-success-popup"
            hideCloseIcon={true}
            titleImg={iconType === "success" ? success_tick : warningImg}
            title={titleMsg}
            subtitle={subtitleMsg}
            middleBtn="Okay"
            handleMiddleBtnClick={handleClosePopup}
          />
        )}
      </>
    );
  };

  const displayPendingViewTableFooter = () => {
    return (
      <OnlinePendingLogsFooterView
        pendingAppointments={pendingAppointments}
        currentPage={apiParams?.page_no}
        totalCount={totalRecordsCount}
        pageSize={Number(DEFAULT_PENDING_PAYLOAD.rows_per_page)}
        onPageChange={onPageChange}
      />
    );
  };

  const renderOnlinePendingLogs = () => {
    return (
      <>
        {pendingAppointments.length > 0 ? (
          pendingAppointments.map((appointment, index) => (
            <OnlinePendingLogsCell
              appointment={appointment}
              key={index}
              doctorRole={doctorRole}
              user_type={userType}
              editCallback={editAppointment}
              deleteCallback={deleteAppointment}
            />
          ))
        ) : (
          <p className="text-center my-4">No data</p>
        )}
      </>
    );
  };

  // <===

  return (
    <>
      <Drawer
        className="pending-appointment"
        anchor="right"
        open={openPopup}
        onClose={onDrawerClose}
        role="presentation"
        style={{ display: showPhysicalConsultationModal ? "none" : "block" }}
      >
        {" "}
        <div>
          <OnlinePendingLogsHeader
            onDrawerClose={onDrawerClose}
            applyParams={applyParams}
            handleRefreshedData={handleRefreshedData}
          />
          <div style={{ padding: "0 15px" }}>
            <OnlinePendingLogsMainView
              params={apiParams}
              headerData={headerData}
              doctorRole={doctorRole}
              user_type={userType}
              applyParams={applyParams}
            />
            {loading ? (
              <div className="text-center">
                <img src={require("../../assets/C2C Loader.gif")} alt="" />
              </div>
            ) : (
              <>{renderOnlinePendingLogs()}</>
            )}
          </div>
          <div style={{ padding: "0 20px" }}>
            {displayPendingViewTableFooter()}
          </div>
        </div>
      </Drawer>

      {createPhysicalConsultModelUI()}
      {showAlertPopup && <AlertMsgPopup alertMsg={alertMsgPop} />}
      {createDeleteModal()}
      {displaySuccessFailurePopup()}
    </>
  );
};
